var quickAdd = {

	request: null,

	init: function () {
		$('.m-quick-add:not(.js-quick-add-done)').each(function () {
			var wrapper = $(this);
			var inputGroup = wrapper.find('.js-input-group');
			var hideInputGroup = wrapper.find('.js-initial-hidden-input-group');
			var addGroup = wrapper.find('.js-add-group');
			var hideAddGroup = wrapper.find('.js-initial-hidden-add-group');
			var addButton = addGroup.find('.js-add');
			var form = addButton.closest('form');

			// init
			hideInputGroup.hide();
			hideAddGroup.hide();

			// click
			addButton.off('click').on('click', function () {
				// show input
				inputGroup.show();
				// hide button
				addGroup.hide();
				// submit
				form.submit();
				return false;
			});

			// done
			wrapper.addClass('js-quick-add-done');
		});
	},

	reset: function (group) {
		group.find('.js-input-group').hide().find('.js-input').val(1);
		group.find('.js-add-group').show();
		group.find('.js-items-group').hide();
	},

	add: function (form) {

		// show loader
		form.find('.js-quick-add-loader').addClass('active');

		// clear request
		if (quickAdd.request != null) {
			quickAdd.request.abort();
			quickAdd.request = null;
		}

		// ajax request
		quickAdd.request = $.ajax({
			url: '/basket/updateajax',
			type: 'POST',
			data: form.serialize(),
			success: function (response) {
				// clear request
				quickAdd.request = null;

				// show confirm or overlay
				if (!response.Success) {
					popups.confirm('Basket', 'Sorry, the product could not be added to your basket.<br />Please refresh and try again.', '', true);
					return;
				}

				// update items count
				form.find('.js-items-count').text(response.Quantity).show();
				if (response.Quantity < 1) {
					form.find('.js-items-group').hide();
				}
				else {
					form.find('.js-items-group').show();
				}

				// update basket counts
				$('.js-basket-count').html(response.TotalItemQuantity);

				// update basket total
				$('.js-basket-total').html('&pound;' + response.SubTotal.toFixed(2));

				// set message
				var message = '{0}<b>{1}</b> {2} {3} your basket';
				message = message.replace('{1}', response.DisplayName);
				if (response.Added) {
					message = message.replace('{0}', response.Quantity + 'x ');
					message = message.replace('{2}', response.Quantity == 1 ? 'was' : 'were');
					message = message.replace('{3}', 'added to');
					// analytics
					site.analytics.track('Add to basket', 'Click', response.DisplayName);
				}
				else {
					message = message.replace('{0}', '');
					message = message.replace('{2}', 'was');
					message = message.replace('{3}', 'removed from');
				}

				// update
				basketOverlay.update(message);
			},
			error: function (e) {
				// show notice
				if (e.statusText != 'abort') {
					popups.confirm('Basket', 'Sorry, the product could not be added to your basket (' + e.statusText.toLowerCase() + '). Please try again.', '', true);
				}
			},
			complete: function () {
				// hide loader
				form.find('.js-quick-add-loader').removeClass('active');
			}
		});
	}

};

$(function () {
	quickAdd.init();
	site.doc.ajaxComplete(function () {
		quickAdd.init();
	});
});